// StepHint — the shared step-guidance banner (BO UI Standard §5), the Dynamic
// Island stepper's companion.  The Island shows WHERE you are; this strip says
// WHAT TO DO next.  Exactly ONE per workflow screen, placed directly under the
// <FormTitle> row and ABOVE the toolbar.
//
// It narrates the ACTIVE step only — "Step N · Name." + one imperative sentence
// naming the controls in bold — and updates live as the stepper advances.  It
// never lists all steps (the Island is the only stepper) and never repeats
// validation errors (those go through useNotify).
//
//   <StepHint tone="guidance">
//     <b>Step 1 · Select Job.</b> Tick <b>any Job ID</b>, then click <b>Load</b>.
//   </StepHint>
import type { ReactNode } from 'react';
import './stepHint.css';

export type StepHintTone = 'guidance' | 'complete' | 'info';

export interface StepHintProps {
  /** guidance = orange (active-step, default) · complete = green (workflow done)
   *  · info = blue (read-only review / tracking screens).  Never red — errors
   *  are toasts, not banners. */
  tone?: StepHintTone;
  children: ReactNode;
  className?: string;
}

export function StepHint({ tone = 'guidance', children, className }: StepHintProps) {
  return (
    <div className={`step-hint step-hint-${tone}${className ? ` ${className}` : ''}`} role="note">
      {children}
    </div>
  );
}
